import React from "react";
import { MusicHallRegisTermConditionStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { userService } from "apiServices";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

// ไฟล์ข้อตกลงและเงื่อนไข แยกตามภาษาที่ลูกค้าเลือก
const TERM_CONDITION_FILE = {
  th: "/assets/docs/Yamaha_Music_Hall_Conditions_TH_Final.pdf",
  en: "/assets/docs/Yamaha_Music_Hall_Conditions_EN_Final.pdf",
};

const MusicHallRegisTermCondition = ({
  initialValues,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    // ค่าเข้ามาได้ทั้ง boolean (จาก checkbox) และ string (จาก query string)
    // string().required() ปล่อย false/"false" ผ่าน จึงต้องเช็คว่ายอมรับจริงเท่านั้น
    is_accept_terms: yup
      .mixed()
      .test(
        "accepted",
        "Please accept the terms and conditions",
        (value) => value === true || value === "true",
      ),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...initialValues,
      special_request_img: initialValues?.special_request_img
        ? [initialValues?.special_request_img]
        : [],
    },
  });

  const { t, i18n } = useTranslation(["common", "form", "room"]);

  return (
    <MusicHallRegisTermConditionStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="additional_layout">
          <div className="additional_text1">
            {t("Terms and Conditions Agreement from Renter", { ns: "form" })}
          </div>
          <div className="additional_text2">
            <a
              className="additional_text2"
              href={
                i18n.language === "en"
                  ? TERM_CONDITION_FILE.en
                  : TERM_CONDITION_FILE.th
              }
              target="_blank"
              rel="noreferrer"
              download
            >
              {t("Download the terms and conditions (PDF)", { ns: "form" })}
            </a>
          </div>
          <div className="checkbox_layout">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputCheckBox
                  {...field}
                  disabled={isDisabledForm}
                  label={t(
                    "I have read and agree to the terms and conditions",
                    { ns: "form" },
                  )}
                  // placeholder={t('test')}
                  errors={errors.is_accept_terms?.message}
                />
              )}
              name="is_accept_terms"
              defaultValue=""
            />
          </div>
        </div>
        <div className="text_area_layout">
          <div className="text_area_text1">
            {t("Special Request", { ns: "form" })}
          </div>
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextArea
                {...field}
                disabled={isDisabledForm}
                placeholder={t("Additional NotesYour answer", { ns: "form" })}
                errors={errors.special_request?.message}
              />
            )}
            name="special_request"
            defaultValue=""
          />
        </div>
        <div className="upload_layout">
          <div className="upload_text1">
            {t("Upload Picture", { ns: "common" })}
          </div>
          <div className="upload_input">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.UploadMultiApi
                  {...field}
                  disabled={isDisabledForm}
                  maxMBFileSizeWarning={8}
                  acceptType="cover"
                  placeholder={t("Upload additional images", { ns: "common" })}
                  addMorePlaceholder={t("Upload additional images", {
                    ns: "common",
                  })}
                  uploadApiUrl={userService.POST_ROOM_UPLOAD}
                  errors={errors.special_request_img?.message}
                />
              )}
              name="special_request_img"
              defaultValue=""
            />
          </div>
          <div className="upload_text2">
            {t("Size limits: 8MB per file", { ns: "form" })}
          </div>
        </div>
        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            {!isDisabledForm && (
              <Buttons.BgStandard
                label={t("Next", { ns: "common" })}
                type="submit"
              />
            )}
          </div>
        </div>
      </form>
    </MusicHallRegisTermConditionStyled>
  );
};

MusicHallRegisTermCondition.propTypes = {};

export default MusicHallRegisTermCondition;
